module.exports = __webpack_public_path__ + "static/media/ResturantTinder.57c45b9b.png";